export default __webpack_public_path__ + "static/media/fifa-logo-icon-dark-mode.1269c69f.png";